




























































































































































































































































import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { namespace } from 'vuex-class';
import _ from 'lodash';
import rest from '@/rest';
import { List } from 'linq-collections';
import MediaPool from './MediaPool.vue';
import { AiCourseWizardVm, ChatMessageVm } from '@/interfaces/AiCourseWizardVm';
import { FileDetailsVm } from '@/interfaces/FileDetailsVm';
import AudioPlayerWithSubtitles from '../Shared/AudioPlayerWithSubtitles.vue';
import AiChatModule from './AiChatModule.vue';
import { exTypeItems } from '@/interfaces/Types';
import { ExType } from '@/interfaces/ExType';
import MarkdownEditor from '../Shared/MarkdownEditor.vue';
import MarkdownViewer from '../Shared/MarkdownViewer.vue';
import ExpandableCard from '../Shared/ExpandableCard.vue';
import { ParamDictionary } from '@/interfaces/ParamDictionary';

interface Step {
  title: string;
  description: string;
  isValid: boolean;
}

const globals = namespace("globals");
const ux = namespace("ux");

@Component({
  components: {
    MediaPool,
    AudioPlayerWithSubtitles,
    AiChatModule,
    MarkdownEditor,
    MarkdownViewer,
    ExpandableCard,
  }
})
export default class AiCourseWizardDlg extends Vue {
  $refs!: {
    mediaPool: MediaPool;
    form1: HTMLFormElement;
    form2: HTMLFormElement;
    form3: HTMLFormElement;
    form4: HTMLFormElement;
    mdCreateCard: any;
  };

  @PropSync("showDialog") syncedShowDialog!: boolean;

  @globals.Getter selectedBundle: any;
  @globals.Action refreshSelectedBundle!: () => Promise<void>;
  @ux.Getter gradientBackground: any;
  @ux.Getter gradientBackground2: any;
  @ux.Getter gradientBackground3: any;
  @ux.Getter gradientText: any;

  isBusy = false;
  isBusyOnDescriptionSuggestion = false;
  mdFileName = "";
  showMarkdownEditor = false;
  selectedFile: FileDetailsVm | null = null;
  formData: AiCourseWizardVm | null = null;
  // fileList: FileDetailsVm[] | null = null;
  chatMessages: ChatMessageVm[] = [];
  exTypeItems = exTypeItems;
  currentStepIndex = 1;
  steps: Step[] = [
    {
      title: 'Dokumente und Medien',
      description: 'Hilfreiche Dokumente und Medien zum Schulungsinhalt',
      isValid: false,
    },
    {
      title: 'Allgemein Informationen',
      description: 'Geben Sie die grundlegenden Informationen zur Schulung ein',
      isValid: false,
    },
    {
      title: 'KI Analyse der Medien',
      description: 'KI Analyse der ausgewählten Materialien',
      isValid: false,
    },
    {
      title: 'Schulungsstruktur festlegen',
      description: 'Aufbau der Schulung festlegen',
      isValid: false,
    },
  ];

  created() {
    // document.addEventListener('keydown', this.handleKeyNavigation);
  }

  beforeDestroy() {
    // document.removeEventListener('keydown', this.handleKeyNavigation);
  }

  @Watch("syncedShowDialog")
  async onShowDialogChanged(val: boolean) {
    if (this.syncedShowDialog) {
      // On dialog open
      this.currentStepIndex = 1;
      this.mdFileName = "";
      this.formData = null;
      await this.loadAiWizardData();
      // this.chatMessages = _.cloneDeep(this.formData!.userChatMessages!);

      // Disable body scroll on iOS
      this.$nextTick(async () => {
        await this.$globalHelper.delay(10);
        const modal = document.querySelector('.modal');
        disableBodyScroll(modal);
      });
    } else {
      // Dialog closing
      clearAllBodyScrollLocks();
    }
  }

  @Watch('currentStepIndex')
  async onStepChange(newIndex: number) {
    this.$emit('step-change', newIndex, this.steps[newIndex - 1]);
    // if (newIndex == 2) {
    //   this.formData!.mediaAiSummaryFiles = this.$refs.mediaPool.getSelectedFiles();
    // }

    // if (newIndex == 3) {
    //   await this.$globalHelper.delay(10);
    //   this.updateForm3Validity();
    // }

    // course structure
    if (newIndex == 4) {
      this.chatMessages = [] as ChatMessageVm[];
      if ((this.formData?.courseModules?.length ?? 0) == 0) {
        console.log("no course modules found, generate with LLM");
        await this.sendCourseWizardDataToLlm();
        await this.$globalHelper.delay(10);
      }
      await this.$globalHelper.delay(10);
      this.chatMessages = _.cloneDeep(this.formData!.userChatMessages!);
      this.updateForm4Validity();
    }
  }

  async onCreateNewMarkdownFile() {
    if (!this.mdFileName || this.mdFileName.trim() == "") return;

    let params: ParamDictionary = { dictionary: {}};
    params.dictionary!["BundleId"] = this.selectedBundle.id!.toString();
    params.dictionary!["FileName"] = this.mdFileName.trim();

    await rest.url("contentManager/createNewMarkdownFile").post(params);
    this.$root.$emit('fileListUpdate:MediaPool'); // notify media pool via global event to refresh file list

    // Close the ExpandableCard after successful creation
    this.$nextTick(() => {
      this.$refs.mdCreateCard?.collapse?.();
    });

    // const newFile = await this.$refs.mediaPool.createNewMarkdownFile(this.mdFileName.trim());
    // if (newFile) {
    //   this.$nextTick(() => {
    //     this.$refs.mediaPool.selectFileInList(newFile);
    //   });
    // }
    this.mdFileName = "";
  }

  onMediaPoolSelectionChanged() {
    if (!this.formData) return;
    this.formData.mediaAiSummaryFiles = this.$refs.mediaPool.getSelectedFiles();
  }


  async loadAiWizardData() {
    this.formData = await rest.url("contentManager/getAiCourseWizardData")
      .query({ bundleId: this.selectedBundle.id })
      .get();

      // this.formData!.bundleId = this.selectedBundle.id;
      // this.formData!.title = this.selectedBundle.name;
  }

  async saveAiWizardData() {
    this.isBusy = true;
    // this.formData!.mediaAiSummaryFiles = this.$refs.mediaPool.getSelectedFiles();

    await rest.url("contentManager/saveAiCourseWizardData")
      .post(this.formData)
      .then((response) => {
      })
      .finally(() => {
        this.isBusy = false;
      });
  }

  async onDescriptionSuggestion() {
    this.isBusyOnDescriptionSuggestion = true;
    await rest.url("contentManager/suggestAiCourseDescription")
      .post(this.formData)
      .then((response) => {
        if (! this.formData) return;
        this.formData.description = response.description;
      })
      .finally(() => {
        this.isBusyOnDescriptionSuggestion = false;
      });
  }

  async onReset() {
    this.isBusy = true;
    await rest.url("contentManager/resetAiCourseWizardData")
      .post(this.formData)
        .then(async (response) => {
          this.formData = response as AiCourseWizardVm;
          // this.fileList = null;
          this.formData!.bundleId = this.selectedBundle.id;
          this.formData!.title = this.selectedBundle.name;
          await this.onMediaPoolSelectionChanged();
          this.goToStep(1);
        })
        .finally(() => {
          this.isBusy = false;
        });
  }

  onEditMarkdown(file) {
    this.selectedFile = file;
    this.showMarkdownEditor = true;
  }

  // get allFilesProcessed(): boolean {
  //   if (this.fileList == null || this.fileList.length == 0) return true;

  //   return this.fileList.filter(file => file.hasAiSummary).length == this.fileList.length;
  // }

  // updateForm3Validity(): void {
  //   this.$set(this.steps[2], 'isValid', this.allFilesProcessed);
  // }

  getExerciseIcon(type: string | null): string {
    return exTypeItems.find(i => ExType[i.value] == type)?.icon || "mdi-help-circle-outline";
  }

  updateForm4Validity(): void {
    if (!this.formData?.courseModules) return;
    this.$set(this.steps[3], 'isValid', this.formData!.courseModules.length > 0);
  }

  get currentStep(): Step {
    return this.steps[this.currentStepIndex - 1];
  }

  get isLastStep(): boolean {
    return this.currentStepIndex === this.steps.length;
  }

  get isCurrentStepValid(): boolean {
    if (!this.syncedShowDialog) return false;

    return this.currentStep.isValid;
  }

  validateCurrentStep(): void {
    switch (this.currentStepIndex) {
      case 1:
        this.$refs.form1?.validate();
        break;
      case 2:
        this.$refs.form2?.validate();
        break;
      case 3:
        this.$refs.form3?.validate();
        break;
      case 4:
        this.$refs.form4?.validate();
        break;
    }
  }

  // handleKeyNavigation(event: KeyboardEvent) {
  //   // arrow left => previous step
  //   if (event.key === 'ArrowLeft' && this.currentStepIndex > 0) {
  //     this.previousStep();
  //   }

  //   // arrow right => next step
  //   if (event.key === 'ArrowRight' && !this.isLastStep && this.isCurrentStepValid) {
  //     this.nextStep();
  //   }
  // }

  async goToStep(index: number) {
    if (index < 1 || index > this.steps.length || index == this.currentStepIndex) return;

    // Optional: Validierung vor dem Sprung zu einem späteren Schritt
    if (index > this.currentStepIndex && this.isCurrentStepValid) {
      this.validateCurrentStep();
    if (!this.isCurrentStepValid) return;

    // Validate previous steps if needed
      for (let i = this.currentStepIndex; i < index; i++) {
        const step = this.steps[i - 1];
        if (!step.isValid) {
          // break, because step from data is not valid
          return;
        }
      }
    }

    await this.saveAiWizardData();
    this.currentStepIndex = index;
  }

  async previousStep() {
    if (this.currentStepIndex > 1) {
      await this.saveAiWizardData();
      this.currentStepIndex--;
    }
  }

  async nextStep() {
    this.validateCurrentStep();

    if (!this.isLastStep && this.isCurrentStepValid) {
      await this.saveAiWizardData();
      this.currentStepIndex++;
    } else if (this.isLastStep && this.isCurrentStepValid) {
      this.complete();
    }
  }

  async complete() {
    await this.saveAiWizardData();
    this.isBusy = true;

    rest.url("contentManager/createCourseModules")
      .post(this.formData)
      .then((response) => {
        this.$emit('complete:CourseWizard', response);
        this.syncedShowDialog = false;
      })
      .finally(async () => {
        this.isBusy = false;
        // await this.refreshSelectedBundle();
      });
  }

  async onNewChatMessage(message: ChatMessageVm) {
    // console.log("onNewChatMessage", message);

    if (!this.formData?.userChatMessages) return;

    this.formData.userChatMessages.push(message);
    await this.sendCourseWizardDataToLlm();
  }

  async sendCourseWizardDataToLlm() {
    this.isBusy = true;
    await rest.url("contentManager/aiCourseSuggestion")
      .post(this.formData)
      .then((response) => {
        // this.$emit('complete', response);
        this.formData = response as AiCourseWizardVm;

        // add new chat messages from response to chatMessages
        let countOfNewMessages = response.userChatMessages.length - this.chatMessages.length;
        let newMessages = response.userChatMessages.slice(-countOfNewMessages);
        let i = this.chatMessages.length + 1;
        newMessages.forEach(m => {
          this.chatMessages.push({
            id: i++,
            message: m.message,
            fromAi: m.fromAi
          });
        });
      })
      .finally(() => {
        this.isBusy = false;
      });
  }

  async onClose() {
    await this.saveAiWizardData();
    this.syncedShowDialog = false;
  }
}
